// extracted by mini-css-extract-plugin
module.exports = {"container":"sparks_container__1cQoP","spark":"sparks_spark__1D1TZ","sparkAnchor":"sparks_sparkAnchor__ApybB","spark-fade-out":"sparks_spark-fade-out__2B1GW"};